import { Link, Text, styled } from '@/theme/index';

interface FcrwarningProps {
  fcraLink: string;
  tosLink: string;
  brandName: string;
  textColor?: string;
}

export const InputLabel = styled('label')(({ theme }) => ({
  lineHeight: '25px',
  color: theme.palette.secondary.contrastText,
}));

export function FcraWarning({
  fcraLink,
  tosLink,
  brandName,
  textColor,
}: FcrwarningProps) {
  return (
    <Text color={textColor} variant="caption" marginTop={2}>
      By clicking Search, you agree NOT to use results to screen/decide upon
      employment, tenants, credit, insurance, admission or other purposes
      restricted by{' '}
      <Link
        href={fcraLink}
        fontWeight="bold"
        target="_blank"
        color="success.main"
      >
        {' '}
        FCRA 15 USC 1681 et seq.
      </Link>{' '}
      , and acknowledge {brandName} is not a consumer reporting agency. Please
      see{' '}
      <Link
        href={tosLink}
        fontWeight="bold"
        target="_blank"
        color="success.main"
      >
        Terms & Conditions
      </Link>{' '}
      .
    </Text>
  );
}
